// account
export const SIGNUP_URL = "/auth/signup";
export const SIGNUP_OAUTH_URL = "/auth/signupOAuth";
export const LOGIN_URL = "/auth/login";
export const LOGIN_OAUTH_URL = "/auth/loginOAuth";
export const FORGOT_PASSWORD_URL = "/auth/forgotPassword";
export const RESET_PASSWORD = "/auth/resetPassword";
export const RESET_PASSWORD_AUTHED_URL = "/auth/resetPasswordAuthed";
export const SET_PASSWORD_AND_VERIFY_URL = "/auth/setPasswordAndVerify";
export const REQUEST_SET_PASSWORD_AND_VERIFY_URL = "/auth/requestSetPasswordAndVerifyLink";
export const REQUEST_EMAIL_VERIFICATION = "/auth/requestEmailVerificationLink";
export const VERIFY_EMAIL_URL = "/auth/verifyEmail";
export const LINK_SOCIAL_URL = "/auth/link-social";
export const UNLINK_SOCIAL_URL = "/auth/unlink-social";
export const LINKED_ACCOUNTS_URL = "/auth/linked-accounts";
export const SET_PASSWORD_URL = "/auth/setPassword";
export const REFRESH_TOKEN_URL = "/auth/refresh";
export const LOGOUT_URL = "/auth/logout";

// mfa
export const MFA_TOTP_SETUP_URL = "/auth/mfa/totp/setup";
export const MFA_TOTP_VERIFY_SETUP_URL = "/auth/mfa/totp/verify-setup";
export const MFA_EMAIL_SETUP_URL = "/auth/mfa/email/setup";
export const MFA_EMAIL_VERIFY_SETUP_URL = "/auth/mfa/email/verify-setup";
export const MFA_EMAIL_SEND_URL = "/auth/mfa/email/send";
export const MFA_STATUS_URL = "/auth/mfa/status";
export const MFA_DISABLE_URL = "/auth/mfa/disable";
export const MFA_VERIFY_URL = "/auth/mfa/verify";

// user
export const GET_USER_URL = "/user";
export const GET_USER_STATS_URL = "/user/stats";
export const REGISTER_USER_URL = "/user";
export const EDIT_USER_URL = "/user";
export const TOGGLE_USER_IS_ACTIVE_URL = "/user/isActive";
export const RECOVER_USER_ACCOUNT_URL = "/user/recoverAccount";
export const DELETE_USER_URL = "/user";

// organization
export const GET_ORGANIZATION_URL = "/organization";
export const GET_ORGANIZATION_STATS_URL = "/organization/stats";
export const REGISTER_ORGANIZATION_URL = "/organization";
export const SIGNUP_ORGANIZATION_URL = "/organization/signup";
export const EDIT_ORGANIZATION_URL = "/organization";
export const TOGGLE_ORGANIZATION_IS_ACTIVE_URL = "/organization/isActive";
export const DELETE_ORGANIZATION_URL = "/organization";

// organization business profile
export const GET_BUSINESS_PROFILE_URL = "/organization/business-profile";
export const UPDATE_BUSINESS_PROFILE_URL = "/organization/business-profile";
export const SUBMIT_BUSINESS_PROFILE_URL = "/organization/business-profile/submit";

// contact
export const GET_CONTACT_URL = "/contact";
export const GET_CONTACT_TIMEZONES_URL = "/contact/timezones";
export const REGISTER_CONTACT_URL = "/contact";
export const ADD_CONTACT_PHONE_NUMBER_URL = "/contact/phoneNumber";
export const EDIT_CONTACT_PHONE_NUMBER_URL = "/contact/updatePhoneNumber";
export const DELETE_CONTACT_PHONE_NUMBER_URL = "/contact/phoneNumber";
// v1 Contact phone dialing info endpoints
export const CONTACTS_NUMBER_INFO_URL = "/contact/number-info";
export const IMPORT_CONTACT_URL = "/contact/import";
export const EDIT_CONTACT_URL = "/contact";
export const TOGGLE_CONTACT_IS_ACTIVE_URL = "/contact/isActive";
export const DELETE_CONTACT_URL = "/contact";
export const ASSIGN_REP_TO_CONTACTS_URL = "/contact/assignRep";
export const MERGE_CONTACTS_URL = "/contact/merge";
export const GET_HUBSPOT_LISTS_URL = "/contact/hubspot-lists";
export const IMPORT_FROM_HUBSPOT_URL = "/contact/import-from-hubspot";
export const SAVE_CONTACT_PROFILE_PICTURE_URL = "/contact";
export const GET_ENGAGEMENT_SUMMARY_URL = "/contact/engagement-summary";
export const MARK_EMAIL_NOTIFICATIONS_SEEN_URL = "/contact/:id/email-notifications/seen";
export const MARK_CHANNEL_NOTIFICATIONS_SEEN_URL = "/contact/:id/channel-notifications/seen";
export const GET_CONTACT_INTERACTION_COUNTS_URL = "/contact/:id/interaction-counts";
export const GET_CONTACT_CHAT_MESSAGES_URL = "/contact/:id/chat-messages";
export const SEND_CONTACT_CHAT_MESSAGE_URL = "/contact/:id/chat-messages";
export const MARK_CONTACT_CHAT_READ_URL = "/contact/:id/chat-messages/seen";
export const ADD_CONTACT_CHAT_REACTION_URL = "/contact/:id/chat-messages/:messageId/reactions";
export const REMOVE_CONTACT_CHAT_REACTION_URL = "/contact/:id/chat-messages/:messageId/reactions";

// note
export const GET_NOTE_URL = "/note";
export const REGISTER_NOTE_URL = "/note";
export const EDIT_NOTE_URL = "/note";
export const TOGGLE_NOTE_IS_ACTIVE_URL = "/note/isActive";
export const DELETE_NOTE_URL = "/note";

// note attachments
export const NOTE_DRAFT_PRESIGN_URL = "/note/attachments/presign";
export const NOTE_DRAFT_CONFIRM_URL = "/note/attachments/confirm";
export const NOTE_DRAFT_DELETE_URL = "/note/attachments/draft";
export const NOTE_PRESIGN_URL = (noteId: string) => `/note/${noteId}/attachments/presign`;
export const NOTE_CONFIRM_URL = (noteId: string) => `/note/${noteId}/attachments/confirm`;
export const NOTE_ATTACHMENT_DELETE_URL = (noteId: string, attachmentId: string) =>
  `/note/${noteId}/attachments/${attachmentId}`;

// tag
export const GET_TAG_URL = "/tag";
export const REGISTER_TAG_URL = "/tag";
export const EDIT_TAG_URL = "/tag";
export const TOGGLE_TAG_IS_ACTIVE_URL = "/tag/isActive";
export const DELETE_TAG_URL = "/tag";

// contact_tag
export const GET_CONTACT_TAG_URL = "/contactTag";
export const REGISTER_CONTACT_TAG_URL = "/contactTag";
export const EDIT_CONTACT_TAG_URL = "/contactTag";
export const TOGGLE_CONTACT_TAG_IS_ACTIVE_URL = "/contactTag/isActive";
export const DELETE_CONTACT_TAG_URL = "/contactTag";

// company
export const GET_COMPANY_URL = "/company";
export const REGISTER_COMPANY_URL = "/company";
export const EDIT_COMPANY_URL = "/company";
export const TOGGLE_COMPANY_IS_ACTIVE_URL = "/company/isActive";
export const DELETE_COMPANY_URL = "/company";
export const ASSIGN_REP_TO_COMPANIES_URL = "/company/assignRep";
export const MERGE_COMPANIES_URL = "/company/merge";
export const SAVE_COMPANY_LOGO_URL = "/company";

// bucket
export const GET_BUCKET_URL = "/bucket";
export const GET_BUCKET_COUNT_URL = "/bucket/count";
export const GET_BUCKET_STATS_URL = "/bucket/stats";
export const REGISTER_BUCKET_URL = "/bucket";
export const EDIT_BUCKET_URL = "/bucket";
export const TOGGLE_BUCKET_IS_ACTIVE_URL = "/bucket/isActive";
export const DELETE_BUCKET_URL = "/bucket";
export const BULK_DELETE_BUCKET_URL = "/bucket/bulk-delete";

// bucket_option
export const GET_BUCKET_OPTION_URL = "/bucketOption";
export const REGISTER_BUCKET_OPTION_URL = "/bucketOption";
export const EDIT_BUCKET_OPTION_URL = "/bucketOption";
export const TOGGLE_BUCKET_OPTION_IS_ACTIVE_URL = "/bucketOption/isActive";
export const DELETE_BUCKET_OPTION_URL = "/bucketOption";

// organization_setting
export const GET_ORGANIZATION_SETTING_URL = "/organizationSetting";
export const REGISTER_ORGANIZATION_SETTING_URL = "/organizationSetting";
export const EDIT_ORGANIZATION_SETTING_URL = "/organizationSetting";
export const TOGGLE_ORGANIZATION_SETTING_IS_ACTIVE_URL = "/organizationSetting/isActive";
export const DELETE_ORGANIZATION_SETTING_URL = "/organizationSetting";
export const GET_AUTO_BUCKET_SETTINGS_URL = "/organizationSetting/auto-bucket";
export const UPDATE_AUTO_BUCKET_SETTINGS_URL = "/organizationSetting/auto-bucket";
export const UPDATE_PARENT_TEMPLATE_FOLDER_ORDER_URL =
  "/organizationSetting/parent-template-folder-order";
export const GET_DIALER_ROTATION_SETTING_URL = "/organizationSetting/dialer-rotation";
export const UPDATE_DIALER_ROTATION_SETTING_URL = "/organizationSetting/dialer-rotation";

// opportunity
export const GET_OPPORTUNITY_URL = "/opportunity";
export const REGISTER_OPPORTUNITY_URL = "/opportunity";
export const EDIT_OPPORTUNITY_URL = "/opportunity";
export const MOVE_OPPORTUNITY_URL = "/opportunity/move";
export const TOGGLE_OPPORTUNITY_IS_ACTIVE_URL = "/opportunity/isActive";
export const DELETE_OPPORTUNITY_URL = "/opportunity";

// organization_setting
export const GET_OPPORTUNITY_STAGE_URL = "/opportunityStage";
export const REGISTER_OPPORTUNITY_STAGE_URL = "/opportunityStage";
export const EDIT_OPPORTUNITY_STAGE_URL = "/opportunityStage";
export const TOGGLE_OPPORTUNITY_STAGE_IS_ACTIVE_URL = "/opportunityStage/isActive";
export const DELETE_OPPORTUNITY_STAGE_URL = "/opportunityStage";

// opportunity_contact
export const GET_OPPORTUNITY_CONTACT_URL = "/opportunityContact";
export const REGISTER_OPPORTUNITY_CONTACT_URL = "/opportunityContact";
export const EDIT_OPPORTUNITY_CONTACT_URL = "/opportunityContact";
export const TOGGLE_OPPORTUNITY_CONTACT_IS_ACTIVE_URL = "/opportunityContact/isActive";
export const DELETE_OPPORTUNITY_CONTACT_URL = "/opportunityContact";

// opportunity_contact
export const GET_INTEGRATION_URL = "/integration";
export const REGISTER_INTEGRATION_URL = "/integration";
export const EDIT_INTEGRATION_URL = "/integration";
export const TOGGLE_INTEGRATION_IS_ACTIVE_URL = "/integration/isActive";
export const DELETE_INTEGRATION_URL = "/integration";

// meeting
export const GET_MEETING_URL = "/meeting";
export const GET_MEETING_STATS_URL = "/meeting/stats";
export const REGISTER_MEETING_URL = "/meeting";
export const GENERATE_MEETING_LINK_URL = "/meeting/generate";
export const EDIT_MEETING_URL = "/meeting";
export const RESCHEDULE_MEETING_URL = "/meeting/reschedule";
export const TOGGLE_MEETING_IS_ACTIVE_URL = "/meeting/isActive";
export const DELETE_MEETING_URL = "/meeting";
export const GET_EXTERNAL_BUSY_SLOTS_URL = "/meeting/external-busy";

// notification
export const GET_NOTIFICATION_URL = "/notification";
export const REGISTER_NOTIFICATION_URL = "/notification";
export const EDIT_NOTIFICATION_URL = "/notification";
export const TOGGLE_NOTIFICATION_IS_ACTIVE_URL = "/notification/isActive";
export const MARK_NOTIFICATION_SEEN_URL = "/notification/seen";
export const DELETE_NOTIFICATION_URL = "/notification";

// template_folder
export const GET_TEMPLATE_FOLDER_URL = "/templateFolder";
export const REGISTER_TEMPLATE_FOLDER_URL = "/templateFolder";
export const EDIT_TEMPLATE_FOLDER_URL = "/templateFolder";
export const TOGGLE_TEMPLATE_FOLDER_IS_ACTIVE_URL = "/templateFolder/isActive";
export const DELETE_TEMPLATE_FOLDER_URL = "/templateFolder";

// parent_template_folder
export const GET_PARENT_TEMPLATE_FOLDER_URL = "/parentTemplateFolder";
export const REGISTER_PARENT_TEMPLATE_FOLDER_URL = "/parentTemplateFolder";
export const EDIT_PARENT_TEMPLATE_FOLDER_URL = "/parentTemplateFolder";
export const TOGGLE_PARENT_TEMPLATE_FOLDER_IS_ACTIVE_URL = "/parentTemplateFolder/isActive";
export const DELETE_PARENT_TEMPLATE_FOLDER_URL = "/parentTemplateFolder";

// template
export const GET_TEMPLATE_URL = "/template";
export const REGISTER_TEMPLATE_URL = "/template";
export const EDIT_TEMPLATE_URL = "/template";
export const COPY_TEMPLATE_URL = "/template/copy";
export const POSITIVE_TEMPLATE_URL = "/template/positive";
export const NEGATIVE_TEMPLATE_URL = "/template/negative";
export const TOGGLE_TEMPLATE_IS_ACTIVE_URL = "/template/isActive";
export const DELETE_TEMPLATE_URL = "/template";
export const CHECK_TEMPLATE_SHORTCUT_URL = "/template/check-shortcut";
export const GET_TEMPLATE_VARIABLES_URL = "/template/variables";
export const UPLOAD_TEMPLATE_ATTACHMENT_URL = "/template/upload";

// enrichment
export const REQUEST_ENRICHMENT_URL = "/integration/fullenrich";

// report
export const GET_DASHBOARD_STATS_URL = "/report/dashboardStats";
export const GET_ANALYTIC_REPORTS_URL = "/report/analyticReports";
export const GET_CONTACT_MOVEMENTS_URL = "/report/contactMovement";
export const GET_METRIC_DETAILS_URL = "/report/metricDetails";
export const GET_CALL_CONNECT_RATE_URL = "/report/callConnectRate";
export const GET_EMAIL_METRICS_URL = "/report/emailMetrics";
export const GET_LINKEDIN_METRICS_URL = "/report/linkedinMetrics";
export const GET_MEETING_BOOKING_METRICS_URL = "/report/meetingBookingMetrics";
export const GET_OPPORTUNITY_DASHBOARD_URL = "/report/opportunityDashboard";
export const GET_STAGE_OPPORTUNITIES_URL = "/report/opportunityDashboard/stage-opportunities";
export const GET_LEAD_SOURCE_OPPORTUNITIES_URL =
  "/report/opportunityDashboard/lead-source-opportunities";
export const GET_PRODUCT_PERFORMANCE_URL = "/report/opportunityDashboard/products";
export const EXPORT_OPPORTUNITY_DASHBOARD_CSV_URL = "/report/opportunityDashboard/export";
export const SAVE_REPORT_VIEW_URL = "/report/view";
export const GET_REPORT_VIEWS_URL = "/report/view";
export const UPDATE_REPORT_VIEW_URL = "/report/view";
export const DELETE_REPORT_VIEW_URL = "/report/view";
export const AI_INSIGHTS_URL = "/report/ai-insights";
export const AI_CHAT_CONVERSATIONS_URL = "/ai-chat/conversations";
export const AGENT_CHAT_URL = "/agent/chat";
export const AGENT_CONVERSATIONS_URL = "/agent/conversations";
export const AGENT_CONTACTS_IMPORT_URL = "/agent/contacts/import";
export const AGENT_CONTACTS_SAVE_URL = "/agent/contacts/save";
export const AGENT_CONTACTS_LOOKUP_URL = "/agent/contacts/lookup";
export const AGENT_LINKEDIN_STATUS_URL = "/agent/linkedin-status";
export const AGENT_ACTIONS_URL = "/agent/actions";
export const AGENT_UNREAD_REPLY_DRAFTS_URL = "/agent/reply-drafts/unread";

// Saved Views (for Contacts/Companies pages)
export const SAVE_SAVED_VIEW_URL = "/saved-views";
export const GET_SAVED_VIEWS_URL = "/saved-views";
export const UPDATE_SAVED_VIEW_URL = "/saved-views";
export const DELETE_SAVED_VIEW_URL = "/saved-views";

// bucket_journey
export const GET_BUCKET_JOURNEY_URL = "/bucketJourney";
export const REGISTER_BUCKET_JOURNEY_URL = "/bucketJourney";
export const EDIT_BUCKET_JOURNEY_URL = "/bucketJourney";
export const TOGGLE_BUCKET_JOURNEY_IS_ACTIVE_URL = "/bucketJourney/isActive";
export const DELETE_BUCKET_JOURNEY_URL = "/bucketJourney";

// subscription
export const CREATE_CHECKOUT_URL = "/billing/checkout";
export const GET_STRIPE_SESSION_INFO_URL = "/billing/checkout/session";
export const GET_STRIPE_BILLING_PORTAL_URL = "/billing/checkout/portal";
export const GET_PLAN_CATALOG_URL = "/billing/plan/catalog";

// billing
export const GET_USAGE_STATS_URL = "/billing/usage/stats";
export const GET_USAGE_HISTORY_URL = "/billing/usage/history";
export const GET_INVOICES_URL = "/billing/invoices";
export const GET_PAYMENT_METHODS_URL = "/billing/payment-methods";
export const DOWNLOAD_INVOICE_URL = "/billing/invoices";
export const GET_SUBSCRIPTION_STATUS_URL = "/billing/subscription-status";
export const CREATE_SETUP_CHECKOUT_URL = "/billing/checkout/setup";
export const START_FREE_TRIAL_URL = "/billing/trial/start";
export const GET_TRIAL_STATUS_URL = "/billing/trial/status";
export const EXPORT_USAGE_HISTORY_URL = "/billing/usage/history/export";
export const GET_ENRICHMENT_DETAILS_URL = "/billing/usage/enrichment-details";
export const EXPORT_ENRICHMENT_DETAILS_URL = "/billing/usage/enrichment-details/export";
export const GET_BILLING_ESTIMATE_URL = "/billing/billing-estimate";
export const PROMO_CODE_VALIDATE_URL = "/billing/promo-code/validate";
export const PROMO_CODE_APPLY_URL = "/billing/promo-code/apply";
export const CREDITS_PURCHASE_URL = "/billing/credits/purchase";
export const CREDITS_BALANCE_URL = "/billing/credits/balance";
export const CREDITS_HISTORY_URL = "/billing/credits/history";
export const CREDITS_CHECKOUT_URL = "/billing/checkout/credits";

// twillio
export const GET_TWILIO_TOKEN_URL = "/twilio/token";
export const ADD_PARTICIPANT_TO_CALL_URL = "/twilio/add-participant";
export const TRANSFER_CALL_URL = "/twilio/transfer-call";
export const PAUSE_RECORDING_URL = "/twilio/recording/pause";
export const RESUME_RECORDING_URL = "/twilio/recording/resume";
export const PLAY_TWILIO_RECORDING_URL = "/twilio/play-recording";
export const SEARCH_TWILIO_NUMBERS_URL = "/twilio/search-numbers";

// call_log
export const GET_CALL_LOG_URL = "/callLog";
export const REGISTER_CALL_LOG_URL = "/callLog";
export const LOG_CALL_LOG_DETAILS_URL = "/callLog/logDetails";
export const DELETE_CALL_LOG_URL = "/callLog";

// organization phone numbers (Twilio numbers owned by organization)
export const GET_PHONE_NUMBER_URL = "/organization/phone-numbers";
export const GET_PHONE_NUMBER_ROTATIONS_URL = "/organization/phone-numbers/rotations";
export const REGISTER_PHONE_NUMBER_URL = "/twilio/purchase-number";
export const DELETE_PHONE_NUMBER_URL = "/organization/phone-numbers";

// call_disposition
export const GET_CALL_DISPOSITION_URL = "/callDisposition";

// dialer
export const GET_DIALER_PRESENCE_URL = "/dialer/presence";
export const SET_DIALER_PRESENCE_URL = "/dialer/presence";
export const CREATE_DIALER_SESSION_URL = "/dialer/sessions";
export const GET_DIALER_SESSIONS_URL = "/dialer/sessions";
export const GET_ACTIVE_DIALER_SESSION_URL = "/dialer/sessions/active";
export const PAUSE_DIALER_SESSION_URL = "/dialer/sessions/active/pause";
export const RESUME_DIALER_SESSION_URL = "/dialer/sessions/active/resume";
export const END_DIALER_SESSION_URL = "/dialer/sessions/active/end";
export const UPDATE_DIALER_SESSION_AI_ASSISTANT_URL = "/dialer/sessions/active/ai-assistant";
export const DELETE_DIALER_SESSION_URL = "/dialer/sessions";
export const SUBMIT_DIALER_WRAPUP_URL = "/dialer/wrapup";

// sequences (email sequencing / drip campaigns)
export const SEQUENCES_URL = "/sequences";
export const ENROLLMENTS_URL = "/enrollments";

// lead_source
export const GET_LEAD_SOURCE_URL = "/leadSource";

// product
export const EDIT_PRODUCT_URL = "/product";

// product_name (organization-scoped catalog of distinct product names)
export const GET_PRODUCT_NAME_URL = "/productName";

// activity_log
export const GET_ACTIVITY_LOG_URL = "/activityLog";
export const REGISTER_ACTIVITY_LOG_URL = "/activityLog";
export const EDIT_ACTIVITY_LOG_URL = "/activityLog";
export const TOGGLE_ACTIVITY_LOG_IS_ACTIVE_URL = "/activityLog/isActive";
export const DELETE_ACTIVITY_LOG_URL = "/activityLog";

// search
export const GLOBAL_SEARCH_URL = "/search/global";

// contact events
export const GET_CONTACT_EVENTS_URL = "/contact-events";

// support
export const SUBMIT_SUPPORT_REQUEST_URL = "/support/contact";
export const SUBMIT_FEATURE_REQUEST_URL = "/support/feature";
export const SUBMIT_BUG_REPORT_URL = "/support/bug";

// bucket_lock
export const GET_BUCKET_LOCK_STATUS_URL = "/bucket-lock/status";
export const GET_BUCKET_LOCK_SETTINGS_URL = "/organizationSetting/bucket-lock";
export const UPDATE_BUCKET_LOCK_SETTINGS_URL = "/organizationSetting/bucket-lock";
export const GET_BUCKET_LOCK_OVERRIDES_URL = "/bucket-lock/overrides";
export const CREATE_BUCKET_LOCK_OVERRIDE_URL = "/bucket-lock/overrides";
export const DELETE_BUCKET_LOCK_OVERRIDE_URL = "/bucket-lock/overrides";

// crm
export const CRM_CONNECTIONS_URL = "/crm/connections";
export const CRM_CONNECT_URL = "/crm";
export const CRM_SYNC_PREFERENCES_URL = "/crm/sync-preferences";

// plan switching
export const PLAN_SWITCH_PREVIEW_URL = "/billing/plan/preview";
export const PLAN_SWITCH_URL = "/billing/plan";
export const PLAN_DOWNGRADE_CANCEL_URL = "/billing/plan/downgrade";

// permissions
export const GET_ROLE_PERMISSIONS_URL = "/permissions";
export const UPDATE_ROLE_PERMISSIONS_URL = (role: string) =>
  `/permissions/role-permissions/${role}`;

// custom fields
export const GET_CUSTOM_FIELDS_URL = "/customFields";
export const CREATE_CUSTOM_FIELD_URL = "/customFields";
export const UPDATE_CUSTOM_FIELD_URL = (id: string) => `/customFields/${id}`;
export const DELETE_CUSTOM_FIELD_URL = (id: string) => `/customFields/${id}`;
